import debounce from "lodash/debounce";
import LayoutManager from "../layout-manager";

type repaintFunc = (nearBottomOfScroll: boolean, visibleComponents: []) => number;

class DefaultMonitor {
    ticking: boolean;
    isTouch: boolean;
    layoutManager: LayoutManager;
    _onRepaint: repaintFunc;
    _element: HTMLElement;
    handleRepaintAndResize: (rebuild?: boolean) => void;

    constructor(layoutManager: LayoutManager, onRepaint: repaintFunc) {
        this.layoutManager = layoutManager;
        this.isTouch = this.layoutManager.isTouch;
        this._onRepaint = onRepaint;
        this.ticking = false;
        this.handleScroll = this.handleScroll.bind(this);
        this.handleResize = debounce(this.handleResize.bind(this), 300);

        this.handleRepaintAndResize = this.handleRepaint.bind(this, true);
        this.handleRepaint = this.handleRepaint.bind(this, false);
    }

    get scrollTop(): number {
        throw new Error("Please implement getter for scroll top ");
    }

    watch(element: HTMLElement): void {
        this._element = element;
        this.handleRepaintAndResize();
    }

    unwatch(): void {}

    handleScroll(): void {
        if (!this.ticking) {
            this.ticking = true;
            // @ts-ignore
            window.requestAnimationFrame(this.handleRepaint);
        }
    }

    handleResize(): void {
        if (!this.ticking) {
            this.ticking = true;
            // @ts-ignore
            window.requestAnimationFrame(this.handleRepaintAndResize);
        }
    }

    handleRepaint = (rebuild: boolean): void => {
        if (rebuild) {
            this.handleViewportChange();
        }
        const nearBottomOfScroll = this.isNearBottom();

        // @ts-ignore
        const visibleComponents = this.layoutManager.getVisibleComponents(this.scrollTop, this.scrollLeft, rebuild);
        // @ts-ignore
        this._onRepaint(nearBottomOfScroll, visibleComponents);
        this.ticking = false;
    };

    isNearBottom(): boolean {
        throw new Error("Please implement isNearBottom");
    }

    handleViewportChange(): void {
        throw new Error("Please implement handleViewportChange");
    }
}

export default DefaultMonitor;
